<template>
  <modal :closeable="false">
    <div class="row">
      <div class="col-4 text-left">
        <outline-button :border="false" @click.prevent="abort" back>
          {{$t('buttons.back')}}
        </outline-button>
      </div>
      <div class="col-8 text-right">
        <router-link :to="{ path: '/signup', query: $route.query }" class="button-link">
          {{ $t('buttons.not_a_member')}}
        </router-link>
      </div>
    </div>
    <h3 class="title mt-3">{{ $t('buttons.login')}}</h3>
    <form class="form needs-validation mt-3" @submit="checkLogin">
      <input-group :label="$t('labels.email')">
        <input
          type="email"
          v-model="email"
          name='email'
        />
      </input-group>
      <input-group :label="$t('labels.password')">
        <input
          type="password"
          v-model="password"
          name="password"
        />
        <p class="mt-1 text-right">
          <router-link :to="{path: '/signup/reset-password', query: $route.query}">
            {{ $t('buttons.forgot_password')}}
          </router-link>
        </p>
      </input-group>
      <p class="mt-3 text-right">
        <primary-button :full-width="false" :disabled="!valid" type="submit" cta>{{ $t('buttons.login')}}</primary-button>
      </p>
    </form>
  </modal>
</template>

<script>
import InputGroup from '@/components/input/InputGroup.vue'
import PrimaryButton from '@/components/buttons/PrimaryButton.vue'
import OutlineButton from '@/components/buttons/OutlineButton.vue'
import Modal from '@/components/modal/ModalRegular.vue'
import {SET_HAS_MEMBERSHIP_ACCESS, SET_IS_ERROR} from '@/store/mutationTypes'

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },

  computed: {
    valid () {
      return this.email.match(/@/) && this.password.length >= 5
    }
  },

  methods: {
    abort() {
      const ticketsUri = this.$store.getters.ticketsUri;
      if (ticketsUri) {
        const url = new URL(ticketsUri, process.env.FG_TICKETS_APP_URL).href;
        window.location = url
      } else {
        window.location = process.env.FG_HOME_URL
        // this.$store.commit(SET_HAS_MEMBERSHIP_ACCESS, false)
        // this.$router.push({path: '/signup', query: this.$route.query})
      }
    },
    checkLogin (e) {
      e.preventDefault()
      this.$store.commit(SET_IS_ERROR, false)
      this.$store.dispatch('login', {email: this.email, password: this.password})
      .then(() => {
        if (!this.$store.getters.isError) {
          this.$store.dispatch('setHideUpgradeWall', false)
          this.$store.dispatch('message', null)
          this.$router.push(this.$route.query.redirect || '/')
        }
      })
    }
  },
  components: {
    InputGroup,
    PrimaryButton,
    Modal,
    OutlineButton
  }
}
</script>

<style lang="scss" scoped>
.button-link {
  margin-top: 15px;


  display: inline-block;
}
.button-row {
  display: flex;
  align-items: baseline;
  padding-bottom: 4rem;
  width: 100%;
}
</style>


